<main class="d-flex align-items-center justify-content-center" style="min-height: 80vh;">
    <div class="text-center px-3">

        <!-- Loading state -->
        <ng-container *ngIf="state === 'loading'">
            <div class="spinner-border text-primary mb-4" role="status" aria-live="polite">
                <span class="visually-hidden">Processing your purchase&hellip;</span>
            </div>
            <h1 class="h3">Processing your purchase&hellip;</h1>
            <p class="text-muted">Hang tight, we&rsquo;re confirming with Stripe.</p>
        </ng-container>

        <!-- Success state -->
        <ng-container *ngIf="state === 'success'">
            <i class="bx bx-check-circle text-success mb-3" style="font-size: 4rem;" aria-hidden="true"></i>
            <h1 class="h3">You&rsquo;re all set!</h1>
            <p class="text-muted mb-4">Your purchase is confirmed. Redirecting you to your courses&hellip;</p>
            <a routerLink="/courses/home" class="btn btn-primary" aria-label="Go to your courses now">
                Go to courses
            </a>
        </ng-container>

        <!-- Error state -->
        <ng-container *ngIf="state === 'error'">
            <i class="bx bx-error-circle text-warning mb-3" style="font-size: 4rem;" aria-hidden="true"></i>
            <h1 class="h3">Something went wrong</h1>
            <p class="text-muted mb-4">We couldn&rsquo;t confirm your purchase. If you were charged, please contact support.</p>
            <div class="d-flex gap-2 justify-content-center flex-wrap">
                <a routerLink="/pricing" class="btn btn-outline-primary" aria-label="Return to pricing page">
                    Back to pricing
                </a>
                <a routerLink="/contact" class="btn btn-outline-secondary" aria-label="Contact support">
                    Contact support
                </a>
            </div>
        </ng-container>

    </div>
</main>
